import Main from "~/js/Main";

export default class FullscreenElement {
	constructor(selector) {
		/**
		 * @type {NodeListOf<HTMLElement>}
		 */
		this.$elems = document.querySelectorAll(selector);
		this.timeout = 0;

		if (this.$elems.length > 0) {
			window.addEventListener("load", this.onUpdate.bind(this));
			window.addEventListener("resize", this.onUpdate.bind(this), {
				passive: true
			});
		}
	}

	resize() {
		let wh = window.innerHeight;
		if (window.getComputedStyle(Main.Instance.getHeaderController().getElement()).position === "sticky") {
			wh -= Main.Instance.getHeaderController().getHeight();
		}

		const adminBar = document.getElementById("wpadminbar");
		if (adminBar) {
			wh -= adminBar.clientHeight;
		}

		this.$elems.forEach(
			(item) => {
				item.style.minHeight = `${wh}px`;
			}
		);
	}

	onUpdate() {
		window.clearTimeout(this.timeout);

		window.setTimeout(this.resize.bind(this), 10);
	}
}
